<template>
  <div
    v-if="appMode !== 'stream-player'"
    class="container"
    :class="appMode + '-mode'">
    <app-header
      :name="product.name"
      :title="product.title"
      :infoMessage="translate(infoMessage)"
      :loaderActive="isLoaderActive"
      :loaderCountdownActive="isLastCountdown"
      :eventId="raceId"
      :roundInfo="roundInfo"
      :nextRoundInfo="nextRoundInfo"
      :countdownTime="countdownTime"
      :progressStartValue="progressStartValue"
      :progressFullWidth="progressFullWidth"
      :clientLogo="clientLogo"
    ></app-header>
    <app-content
      :stage="currentStage"
    ></app-content>
  </div>
  <div v-else>
    <stream-player></stream-player>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppHeader from '@nsftx/games-visualization-sdk/src/components/AppHeader';
import { translate } from '@nsftx/games-visualization-sdk/src/utility';
import { eventBus } from '../utility';
import StreamPlayer from './StreamPlayer';
import AppContent from './AppContent';

export default {
  name: 'AppWrapper',
  components: {
    AppHeader,
    AppContent,
    StreamPlayer,
  },
  data() {
    return {
      progressFullWidth: true,
      clientLogo: this.$store.getters.isLogoEnabled && this.$store.getters.config.logo.path,
      roundInfo: {
        active: false,
        text: this.translate('roundNumber'),
      },
      nextRoundInfo: {
        active: false,
        text: this.translate('bettingTimeLeft'),
      },
      progressStartValue: 0,
    };
  },
  computed: {
    ...mapGetters([
      'appMode',
      'bgVideo',
      'countdownTime',
      'currentStage',
      'infoMessage',
      'isLoaderActive',
      'isLastCountdown',
      'isStateMode',
      'product',
      'raceId',
      'translations',
    ]),
  },
  watch: {
    translations() {
        this.roundInfo.text = this.translate('roundNumber');
        this.nextRoundInfo.text = this.translate('bettingTimeLeft');
    }
  },
  methods: {
    ...mapActions([
      'activateLoader',
      'deactivateLoader',
    ]),
    loaderReactivate(delay) {
      this.activateLoader();
      setTimeout(() => {
        if (!this.isStateMode && !this.isLastCountdown) {
          this.deactivateLoader();
        }
      }, delay || 0);
    },
    translate(key) {
      return translate(key);
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLastCountdown) {
        this.deactivateLoader();
      }
    }, 2000);

    eventBus.$on('event', (value) => {
      switch (value) {
        case 'countdown':
          this.loaderReactivate(1500);
          this.progressFullWidth = false;
          this.roundInfo.active = false;
          this.nextRoundInfo.active = true;
          this.progressStartValue = this.countdownTime;
          break;
        case 'race':
        case 'results':
          this.loaderReactivate(1500);
          this.progressFullWidth = true;
          this.roundInfo.active = true;
          this.nextRoundInfo.active = false;
          break;
        default:
          break;
      }
    });
  },
  beforeDestroy() {
    eventBus.$off('event');
  },
};
</script>

<style lang="scss">
.container {
  position: relative;
  width: 100%;
  height: 100%;
  background: {
    image: url('../assets/bg.png');
    repeat: no-repeat;
    size: 100% 100%;
    position: center;
  }
}
.screen-content {
  z-index: 1;
}
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  height: 100%;
  z-index: 0;
}
</style>
